/**
 * Knowledge Base articles that offer a "Go to …" CTA into the live UI.
 * `path` may include a `helpGuide` query consumed by Layout / pages.
 */
export type KnowledgeBaseTryIt = {
  path: string;
  /** i18n key under the app namespace (e.g. knowledgeBase.goToOrders). */
  labelKey: string;
};

export const HELP_GUIDE_CHANGE_LANGUAGE = 'change-language';
export const HELP_GUIDE_APPEARANCE = 'appearance-theme';
/** Walkthrough: summary → filters → list → create button → create dialog. */
export const HELP_GUIDE_ORDERS = 'orders';
/** Create Order dialog tip only. */
export const HELP_GUIDE_ORDERS_CREATE = 'orders-create';
/** Summary cards tip only. */
export const HELP_GUIDE_ORDERS_SUMMARY = 'orders-summary';
/** Search / status filter tip only. */
export const HELP_GUIDE_ORDERS_SEARCH_FILTER = 'orders-search-filter';
/** Walkthrough: period → lines → accepts extra → save. */
export const HELP_GUIDE_SUPPLY = 'supply';
/** Single tip: material lines table. */
export const HELP_GUIDE_SUPPLY_LINES = 'supply-material-lines';
/** Single tip: accept extra deliveries switch. */
export const HELP_GUIDE_SUPPLY_ACCEPTS_EXTRA = 'supply-accepts-extra';
/** Walkthrough: period toggle → fulfillment → table → orders. */
export const HELP_GUIDE_DASHBOARD = 'dashboard';

export const KNOWLEDGE_BASE_TRY_IT: Record<string, KnowledgeBaseTryIt> = {
  'supply-overview': {
    path: `/supply?helpGuide=${HELP_GUIDE_SUPPLY}`,
    labelKey: 'knowledgeBase.goToSupplyOverview',
  },
  'supply-material-lines': {
    path: `/supply?helpGuide=${HELP_GUIDE_SUPPLY_LINES}`,
    labelKey: 'knowledgeBase.goToMaterialLines',
  },
  'supply-accepts-extra': {
    path: `/supply?helpGuide=${HELP_GUIDE_SUPPLY_ACCEPTS_EXTRA}`,
    labelKey: 'knowledgeBase.goToAcceptExtraDeliveries',
  },
  'dashboard-overview': {
    path: `/dashboard?helpGuide=${HELP_GUIDE_DASHBOARD}`,
    labelKey: 'knowledgeBase.goToDashboard',
  },
  'orders-overview': {
    path: `/orders?helpGuide=${HELP_GUIDE_ORDERS}`,
    labelKey: 'knowledgeBase.goToOrdersOverview',
  },
  'orders-summary': {
    path: `/orders?helpGuide=${HELP_GUIDE_ORDERS_SUMMARY}`,
    labelKey: 'knowledgeBase.goToOrdersSummaryCards',
  },
  'orders-search-filter': {
    path: `/orders?helpGuide=${HELP_GUIDE_ORDERS_SEARCH_FILTER}`,
    labelKey: 'knowledgeBase.goToSearchAndFilterOrders',
  },
  'orders-create': {
    path: `/orders?helpGuide=${HELP_GUIDE_ORDERS_CREATE}`,
    labelKey: 'knowledgeBase.goToCreateAnOrder',
  },
  'change-language': {
    path: `/supply?helpGuide=${HELP_GUIDE_CHANGE_LANGUAGE}`,
    labelKey: 'knowledgeBase.goToChangeLanguage',
  },
  'appearance-theme': {
    path: `/supply?helpGuide=${HELP_GUIDE_APPEARANCE}`,
    labelKey: 'knowledgeBase.goToAppearance',
  },
};
